import { apiClient } from './api';

export const versionResource = {
  getVersion: apiClient.get<{ data: { version: string }}>('/version'),
};
